var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"steps",style:(`width: ${(Number(_vm.steps) + 1) * 75}px`)},_vm._l((Number(_vm.steps)),function(index){return _c('div',[(index === Number(_vm.active))?_c('div',{staticClass:"rounded-circle step active"}):_c('div',{staticClass:"rounded-circle step inactive"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }